const API_KEY = import.meta.env.VITE_SEZNAM_API_KEY;

// Reusable — can be imported from Vue components
export async function fetchAddressSuggestions(query) {
  if (!query || query.length < 2) return [];
  const url = new URL('https://api.mapy.com/v1/suggest');
  url.searchParams.set('apikey', API_KEY);
  url.searchParams.set('query', query);
  url.searchParams.set('lang', 'cs');
  url.searchParams.set('limit', '8');
  url.searchParams.set('type', 'regional.municipality,regional.street,regional.address');
  url.searchParams.set('locality', 'cz');

  const res = await fetch(url);
  if (!res.ok) return [];
  const data = await res.json();
  return data.items || [];
}

// ZIP is only present on regional.address items, not on municipalities or streets.
// Uses /v1/geocode (not suggest) — suggest with type=regional.address can return
// streets from unrelated cities for ambiguous city name queries.
export async function fetchZipForCity(cityName, streetName) {
  if (!cityName) return '';
  const query = [streetName, cityName].filter(Boolean).join(', ');
  const url = new URL('https://api.mapy.com/v1/geocode');
  url.searchParams.set('apikey', API_KEY);
  url.searchParams.set('query', query);
  url.searchParams.set('lang', 'cs');
  url.searchParams.set('limit', '1');
  url.searchParams.set('type', 'regional.address');
  url.searchParams.set('locality', 'cz');

  const res = await fetch(url);
  if (!res.ok) return '';
  const data = await res.json();
  return data.items?.[0]?.zip || '';
}

// Parses a Mapy.cz suggest item into structured address fields
// https://api.mapy.com/v1/docs/geocode/#/
export function parseAddressItem(item) {
  const rs = item.regionalStructure || [];

  const street        = rs.find(function (r) { return r.type === 'regional.street'; })?.name;
  const houseNum      = rs.find(function (r) { return r.type === 'regional.address'; })?.name;
  const city          = rs.find(function (r) { return r.type === 'regional.municipality'; })?.name || item.name;
  const regions       = rs.filter(function (r) { return r.type === 'regional.region'; });
  const districtEntry = regions.find(function (r) { return r.name.toLowerCase().startsWith('okres '); });
  const regionEntry   = regions.find(function (r) { return !r.name.toLowerCase().startsWith('okres '); });

  return {
    street:       [street, houseNum].filter(Boolean).join(' '),
    zip:          item.zip || '',
    city:         city,
    districtName: districtEntry ? districtEntry.name.replace(/^okres /i, '') : '',
    regionName:   regionEntry ? regionEntry.name.replace(/^kraj /i, '') : '',
    label:        item.name + (item.location ? ', ' + item.location : ''),
  };
}

// Vanilla JS init for the user-profile page
document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('profile-address-search');
  if (!searchInput) return;

  let debounceTimer = null;
  let dropdown = null;

  function createDropdown() {
    const el = document.createElement('div');
    el.className = 'address-suggest-dropdown';
    searchInput.parentNode.style.position = 'relative';
    searchInput.parentNode.insertBefore(el, searchInput.nextSibling);
    return el;
  }

  function showDropdown(items) {
    if (!dropdown) dropdown = createDropdown();
    dropdown.innerHTML = '';
    if (!items.length) { dropdown.hidden = true; return; }

    items.forEach(function (item) {
      const parsed = parseAddressItem(item);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'address-suggest-item';
      btn.textContent = parsed.label;
      btn.addEventListener('click', function () { selectItem(parsed); });
      dropdown.appendChild(btn);
    });
    dropdown.hidden = false;
  }

  function hideDropdown() {
    if (dropdown) dropdown.hidden = true;
  }

  async function selectItem(parsed) {
    // ZIP is only available for regional.address; resolve it via second call for municipalities/streets
    let zip = parsed.zip;
    if (!zip && parsed.city) {
      zip = await fetchZipForCity(parsed.city, parsed.street);
    }

    document.getElementById('profile-street').value               = parsed.street;
    document.getElementById('profile-zip-code').value             = zip;
    document.getElementById('profile-city').value                 = parsed.city;
    document.getElementById('profile-district-name').value        = parsed.districtName;
    document.getElementById('profile-district-name-hidden').value = parsed.districtName;

    searchInput.value = [parsed.street, parsed.city].filter(Boolean).join(', ');

    // Sync region select with the resolved region name
    const select = document.querySelector('select[name="user[region]"]');
    if (select && parsed.regionName) {
      Array.from(select.options).forEach(function (opt) {
        if (opt.text.trim() === parsed.regionName || opt.value === parsed.regionName) {
          select.value = opt.value;
        }
      });
    }

    // Update hidden region field — the select is disabled so it doesn't submit its value
    const hiddenRegion = document.querySelector('input[name="user[region]"]');
    if (hiddenRegion && parsed.regionName) hiddenRegion.value = parsed.regionName;

    // Reveal detail fields
    const detail = document.getElementById('profile-address-detail');
    detail.hidden = false;
    detail.classList.add('mt-3');

    hideDropdown();
  }

  searchInput.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    const query = this.value.trim();
    if (query.length < 2) { hideDropdown(); return; }

    debounceTimer = setTimeout(async function () {
      const items = await fetchAddressSuggestions(query);
      showDropdown(items);
    }, 300);
  });

  document.addEventListener('click', function (e) {
    if (!searchInput.contains(e.target) && (!dropdown || !dropdown.contains(e.target))) {
      hideDropdown();
    }
  });
});
